module.exports = __webpack_public_path__ + "pnskfsquadron/img/en-slider-3.jpg?8f9655ad";